import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../services/instance";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";

export const getFeedbacks = createAsyncThunk(
  "getFeedbacks",
  async (userId, currentPage) => {
    try {
      const response = await instance.get(
        endpoints.getFeedbacks(userId, currentPage)
      );
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);

export const feedBackReply = createAsyncThunk(
  "feedBackReply",
  async (data) => {
    try {
      const response = await api.post(endpoints.feedbackReply(), data);
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);
